/**
 * Sand & Silk — Theme JS
 * Vanilla JavaScript (no frameworks)
 */

(function() {
  'use strict';

  /* ---------------------------
     Mobile Navigation
  --------------------------- */
  const mobileToggle = document.querySelector('.mobile-nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function() {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ---------------------------
     Sticky Header scroll class
  --------------------------- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---------------------------
     Sold-out option labelling

     Native <option> ignores CSS text-decoration in most browsers, so this
     used to draw a line through each character with the Unicode combining
     long stroke overlay. That line rendered far too faintly on phones — and
     on some letters it merged into the glyph itself (L became Ł), which
     read as a typo rather than as sold out.

     Plain words instead. Option text always renders, at full contrast, on
     every device, and a screen reader announces it correctly too.
  --------------------------- */
  var SOLD_OUT_SUFFIX = ' — Sold out';

  function markSoldOut(text) {
    return text + SOLD_OUT_SUFFIX;
  }

  function refreshOptionAvailability(form) {
    if (!form) return;
    var variantsJson = form.querySelector('[data-product-variants]');
    if (!variantsJson) return;

    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-select]'));
    if (!selects.length) return;
    var chosen = selects.map(function(s) { return s.value; });

    selects.forEach(function(select, idx) {
      Array.prototype.slice.call(select.options).forEach(function(opt) {
        var label = opt.getAttribute('data-label') || opt.value;

        // Would this value be purchasable, given the other options as currently chosen?
        var combo = chosen.slice();
        combo[idx] = opt.value;

        var isAvailable = variants.some(function(variant) {
          if (!variant.available) return false;
          return variant.options.every(function(o, i) { return o === combo[i]; });
        });

        opt.textContent = isAvailable ? label : markSoldOut(label);
        opt.setAttribute('data-sold-out', isAvailable ? 'false' : 'true');
      });
    });
  }

  /* ---------------------------
     Product variant selector
  --------------------------- */
  const variantSelects = document.querySelectorAll('[data-variant-select]');

  // Mark sold-out values on first paint
  var seenForms = [];
  variantSelects.forEach(function(select) {
    var f = select.closest('form');
    if (f && seenForms.indexOf(f) === -1) {
      seenForms.push(f);
      refreshOptionAvailability(f);
    }
  });

  variantSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      const form = this.closest('form');
      if (!form) return;

      // Re-evaluate which values are still purchasable
      refreshOptionAvailability(form);

      // Build selected options array
      const selects = form.querySelectorAll('[data-variant-select]');
      const selectedOptions = Array.from(selects).map(function(s) { return s.value; });

      // Find matching variant from JSON data
      const variantsJson = form.querySelector('[data-product-variants]');
      if (!variantsJson) return;

      try {
        var variants = JSON.parse(variantsJson.textContent);
      } catch(e) { return; }

      var matchedVariant = variants.find(function(variant) {
        return variant.options.every(function(opt, idx) {
          return opt === selectedOptions[idx];
        });
      });

      if (matchedVariant) {
        // Update hidden variant ID input
        var variantInput = form.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = matchedVariant.id;

        // Calculate sale discount if product is on sale
        var isSale = form.getAttribute('data-sale-product') === 'true';
        var discountPercent = parseInt(form.getAttribute('data-sale-discount')) || 20;

        var displayPrice = matchedVariant.price;
        var displayComparePrice = matchedVariant.compare_at_price;

        if (isSale) {
          displayComparePrice = matchedVariant.price;
          displayPrice = Math.round(matchedVariant.price * (100 - discountPercent) / 100);
        }

        // Update price display
        var priceEl = document.querySelector('[data-product-price]');
        if (priceEl) {
          priceEl.textContent = formatMoney(displayPrice);
        }

        // Update compare-at price
        var comparePriceEl = document.querySelector('[data-compare-price]');
        if (comparePriceEl) {
          if (displayComparePrice && displayComparePrice > displayPrice) {
            comparePriceEl.textContent = formatMoney(displayComparePrice);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        // Update add-to-cart button
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (addBtn) {
          addBtn.disabled = !matchedVariant.available;
          addBtn.textContent = matchedVariant.available ? 'Add to Cart' : 'Sold Out';
        }

        // Update main product image if variant has an image
        if (matchedVariant.featured_image) {
          var mainImg = document.querySelector('.product-details__main-image');
          if (mainImg) {
            mainImg.src = matchedVariant.featured_image.src;
            mainImg.alt = matchedVariant.featured_image.alt || '';
          }
        }
      }
    });
  });

  /* ---------------------------
     Product image gallery
  --------------------------- */
  const thumbnails = document.querySelectorAll('.product-details__thumbnail');
  const mainImage = document.querySelector('.product-details__main-image');

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImage) {
        mainImage.src = this.getAttribute('data-full-src') || this.src;
        mainImage.alt = this.alt;
      }
      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* ---------------------------
     AJAX Cart (add to cart)
  --------------------------- */
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var addBtn = form.querySelector('[data-add-to-cart]');

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (addBtn) {
          addBtn.textContent = 'Added!';
          setTimeout(function() {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }, 1500);
        }
        updateCartCount();
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        }
      });
    });
  });

  /* ---------------------------
     Update cart count in header
  --------------------------- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.header-cart-count');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function(err) { console.error('Cart count error:', err); });
  }

  /* ---------------------------
     Format money helper
  --------------------------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------------------
     Featured Products Carousel
  --------------------------- */
  const carouselTracks = document.querySelectorAll('[data-carousel-track]');

  carouselTracks.forEach(function(track) {
    const wrapper = track.closest('.carousel-wrapper');
    if (!wrapper) return;

    const prevBtn = wrapper.querySelector('[data-carousel-prev]');
    const nextBtn = wrapper.querySelector('[data-carousel-next]');

    if (!prevBtn || !nextBtn) return;

    function updateArrowStates() {
      const scrollLeft = track.scrollLeft;
      const maxScrollLeft = track.scrollWidth - track.clientWidth;

      if (scrollLeft <= 5) {
        prevBtn.setAttribute('disabled', 'true');
        prevBtn.disabled = true;
      } else {
        prevBtn.removeAttribute('disabled');
        prevBtn.disabled = false;
      }

      if (scrollLeft >= maxScrollLeft - 5) {
        nextBtn.setAttribute('disabled', 'true');
        nextBtn.disabled = true;
      } else {
        nextBtn.removeAttribute('disabled');
        nextBtn.disabled = false;
      }
    }

    nextBtn.addEventListener('click', function() {
      const firstSlide = track.querySelector('.product-card');
      const slideWidth = firstSlide ? firstSlide.offsetWidth : track.offsetWidth / 4;
      const gapWidth = 24;

      const scrollAmount = track.clientWidth > 768 ? (slideWidth + gapWidth) * 2 : (slideWidth + gapWidth);

      track.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });

    prevBtn.addEventListener('click', function() {
      const firstSlide = track.querySelector('.product-card');
      const slideWidth = firstSlide ? firstSlide.offsetWidth : track.offsetWidth / 4;
      const gapWidth = 24;

      const scrollAmount = track.clientWidth > 768 ? (slideWidth + gapWidth) * 2 : (slideWidth + gapWidth);

      track.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', updateArrowStates, { passive: true });

    // Initial check
    setTimeout(updateArrowStates, 100);
    window.addEventListener('resize', updateArrowStates, { passive: true });
  });

})();
